import fallbackThumbnailUrl from '../assets/thumbnails/game_thumbnail_seven.png';
import type { Game } from '../stores/game/types';

export const getThumbnailUrl = (game: Game, key: 'Short' | 'Long' = 'Short'): string =>
  game[`thumbnail${key || ''}HrUrl`] || game[`thumbnail${key || ''}Url`] || fallbackThumbnailUrl;
